import cx from 'classnames';
import React from 'react';

import { Icon, IconArrowBigRight, IconMaintenance } from '@flixbus/honeycomb-icons-react';

import { formatTime } from 'utils/datetime';

import { STATION_TEXT } from './text';

import styles from './styles.module.css';

const renderTime = (planned, actual, timezone) => {
	if (!actual) {
		return <span className={styles.time}>{formatTime(planned, { timezone })}</span>;
	}

	return (
		<span className={styles.timeStack} data-testid="time-stack">
			<span className={`${styles.time} ${styles.timePlanned}`}>
				{formatTime(planned, { timezone })}
			</span>
			<span className={styles.timeActual}>{formatTime(actual, { timezone })}</span>
		</span>
	);
};

const Station = ({
	station,
	isFirst,
	isLast,
	timezone,
	actualDeparture = null,
	actualArrival = null,
}) => {
	const { arrival, departure, code, name, isVirtual } = station;
	const isInter = !isFirst && !isLast;

	const renderIcon = () => {
		if (isFirst)
			return (
				<div className={styles.startIcon}>
					<div className={styles.startDot} />
					<Icon extraClasses={styles.startIcon} InlineIcon={IconArrowBigRight} />
				</div>
			);
		if (isLast)
			return (
				<div className={styles.finishIcon}>
					<div className={styles.finishLine} />
					<div className={styles.finishDot} />
				</div>
			);
		if (isInter) return <Icon InlineIcon={IconArrowBigRight} />;
	};

	return (
		<div
			className={cx(styles.station, {
				[styles.inter]: isInter,
				[styles.edge]: !isInter,
				[styles.left]: isFirst,
				[styles.right]: isLast,
			})}
		>
			{isVirtual ? (
				<div
					className={styles.breakdownBadge}
					data-testid="virtual-station-badge"
					aria-label={STATION_TEXT.breakdownBadgeAriaLabel}
				>
					<Icon InlineIcon={IconMaintenance} size={5} extraClasses={styles.breakdownIcon} />
				</div>
			) : (
				<>
					<div className={styles.code}>{code}</div>
					<div className={styles.name}>{name}</div>
				</>
			)}

			<div className={styles.timing}>
				{!isFirst && (
					<div className={styles.timingPart} data-testid="timing-part">
						{renderTime(arrival, actualArrival, timezone)}
						{renderIcon()}
					</div>
				)}

				{isInter && <div className={styles.routeline} data-testid="routeline" />}
				{!isLast && (
					<div className={styles.timingPart} data-testid="timing-part">
						{renderIcon()}
						{renderTime(departure, actualDeparture, timezone)}
					</div>
				)}
			</div>
		</div>
	);
};

export default Station;
